import styles from "./styles/Footer.module.css";
import FacebookIcon from "./assets/icons/facebook.svg";
import InstagramIcon from "./assets/icons/instagram.svg";
import TikTokIcon from "./assets/icons/tiktok.svg";
import XIcon from "./assets/icons/x.svg";
import TelegramIcon from "./assets/icons/telegram.svg";
import { FaEnvelope } from "react-icons/fa";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerDesktopContainer}>
        <div className={styles.leftSection}>
          <img src="/images/Xenorize logo_Purple_D.png" alt="Xenorize Logo" />
          <p>2025 Copyright by Xenorize. All rights reserved.</p>
          {/* <a href="mailto:support@xenorize.com" className={styles.partnershipButton}>
              <FaEnvelope style={{ marginRight: "8px" }} />
              support@xenorize.com
            </a>
          <div className={styles.iconContainer}>
            <a href="https://www.facebook.com/Xenorize" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img src={FacebookIcon} alt="Facebook" /></a>
            <a href="https://x.com/xenorize" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)"><img src={XIcon} alt="X (Twitter)" /></a>
            <a href="https://www.instagram.com/xenorize.global/ " target="_blank" rel="noopener noreferrer" aria-label="Instagram"><img src={InstagramIcon} alt="Instagram" /></a>
            <a href="https://www.tiktok.com/@xenorize.global" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><img src={TikTokIcon} alt="TikTok" /></a>
            <a href="https://t.me/XenorizeTech" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><img src={TelegramIcon} alt="Telegram" /></a>
          </div> */}
        </div>

        {/* <div className={styles.centerSection}>
          <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </div> */}

        <div className={styles.rightSection}>
          {/* <a href="https://www.facebook.com/Xenorize" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img src={FacebookIcon} alt="Facebook" /></a>
          <a href="https://x.com/xenorize" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)"><img src={XIcon} alt="X (Twitter)" /></a>
          <a href="https://www.instagram.com/xenorize.global/ " target="_blank" rel="noopener noreferrer" aria-label="Instagram"><img src={InstagramIcon} alt="Instagram" /></a>
          <a href="https://www.tiktok.com/@xenorize.tech" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><img src={TikTokIcon} alt="TikTok" /></a>
          <a href="https://t.me/XenorizeTech" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><img src={TelegramIcon} alt="Telegram" /></a> */}
          <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <a
            href="https://xenorize.freshdesk.com/support/tickets/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
        </div>

        <div>
          {/* <a
            href="mailto:support@xenorize.com"
            className={styles.partnershipButton}
          >
            <FaEnvelope style={{ marginRight: "8px" }} />
            support@xenorize.com
          </a> */}
          <div className={styles.iconContainer}>
            <a
              href="https://www.facebook.com/Xenorize"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <img src={FacebookIcon} alt="Facebook" />
            </a>
            <a
              href="https://x.com/xenorize"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
            >
              <img src={XIcon} alt="X (Twitter)" />
            </a>
            <a
              href="https://www.instagram.com/xenorize.global/ "
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <img src={InstagramIcon} alt="Instagram" />
            </a>
            <a
              href="https://www.tiktok.com/@xenorize.global"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <img src={TikTokIcon} alt="TikTok" />
            </a>
            <a
              href="https://t.me/XenorizeTech"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <img src={TelegramIcon} alt="Telegram" />
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footerMobileContainer}>
        {/* <div className={styles.leftSection}>
          <img src="/images/Xenorize logo_Purple_D.png" alt="Xenorize Logo" />
          <a
            href="mailto:support@xenorize.com"
            className={styles.partnershipButton}
          >
            <FaEnvelope style={{ marginRight: "8px" }} />
            support@xenorize.com
          </a>
        </div> */}

        <div className={styles.centerSection}>
          <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <a
            href="https://xenorize.freshdesk.com/support/tickets/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
        </div>
        <div className={styles.rightSection}>
          {/* <a href="#" aria-label="YouTube"><img src={YouTubeIcon} alt="YouTube" /></a> */}
          <a
            href="https://www.facebook.com/Xenorize"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img src={FacebookIcon} alt="Facebook" />
          </a>
          <a
            href="https://x.com/xenorize"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X (Twitter)"
          >
            <img src={XIcon} alt="X (Twitter)" />
          </a>
          <a
            href="https://www.instagram.com/xenorize.global/ "
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src={InstagramIcon} alt="Instagram" />
          </a>
          <a
            href="https://www.tiktok.com/@xenorize.global"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <img src={TikTokIcon} alt="TikTok" />
          </a>
          <a
            href="https://t.me/XenorizeTech"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Telegram"
          >
            <img src={TelegramIcon} alt="Telegram" />
          </a>
        </div>
        <p>© 2025. All rights reserved.</p>
      </div>
    </footer>
  );
};
